import React from 'react'
import { Store } from './Store'
import PropertiesList from './PropertiesList'
import { EllipsisLoader } from '@components/Loaders'
import { Redirect } from '@reach/router'

export default function PropertiesPage(props: any): React.ReactElement {
  // @ts-ignore
  const [state, dispatch] = React.useContext(Store)

  React.useEffect(() => {
    dispatch({ type: 'REQUIRE_ALL_PROPERTY_SUMMARIES' })
  }, [state.properties])

  switch (state.mode) {
  case 'Error':
    return <div>Error: {state.errorMessage}</div>
  default:
    if (!state.properties || Object.entries(state.properties).length === 0) {
      return (
          <div className="-mod-margin-top">
            <EllipsisLoader />
          </div>
      )
    } else if (state.propertiesCount === 1) {
      return (
          <Redirect
            noThrow
            from="/properties/"
            to={`/properties/${state.properties?.[
              Object.keys(state?.properties)[0]
            ]?.id.toString()}`}
          />
      )
    }
  }
  return <PropertiesList properties={state.properties} />
}
